




























































import { computed, defineComponent, reactive, ref } from '@vue/composition-api';

import svgCom from '@components/Svg/index';
import TCaptcha from '@components/TCaptcha/index.vue';
import VerifyCode from '@components/VerifyCode/index.vue';
import PwdInput from '@components/PwdInput/index.vue';
import DealAndPolicyDialog from '@components/dealAndPolicyDialog/index.vue';
import request from '@utils/request';
import { useLogin } from '@/useable/login';
import {
  verifyMsg,
  verificaEmail,
  verificaPassword,
  verificaCode
} from '@/useable/verification';
import { session } from '@/utils/storage';
import config from '@/config';
import { Message } from 'element-ui';
import { decrypt, encrypt } from '@/utils/aes';
import md5 from 'js-md5';

export default defineComponent({
  name: 'Login',
  components: {
    svgCom,
    PwdInput,
    TCaptcha,
    VerifyCode,
    DealAndPolicyDialog
  } as any,
  setup(prop: any, { root }) {
    const { workEmail } = root.$route.params;
    const dialogReadTitle = ''; // 弹框标题
    const dialogReadType = ''; // 弹框类型
    const checked = ref(false); // 是否勾选协议
    const dealVisible = ref(false); // 显示协议弹框
    const formRoot = ref<any>(null);
    const multiCompany = ref<any>(false); // 是否绑定多个公司
    const companyLen = ref(-1); // 绑定公司数量
    const hideForm = ref<any>(false);
    const form = reactive({
      workEmail: workEmail ? workEmail : '',
      password: '',
      supplierCertId: computed(() => companyInfor.selectCompany.supplierCertId),
      supplierId: computed(() => companyInfor.selectCompany.supplierId),
      supplierName: computed(() => companyInfor.selectCompany.supplierName),
      checkCode: '',
    });

    // 登录按钮
    const login = async () => {
      console.log('login');
      if (!form.supplierId) {
        Message.error('请先选择登录企业');
        return;
      }
      await useLogin(form);
    };

    const imageCheckParams = reactive({
      randStr: '',
      ticket: '',
    });

    // 图片校准
    const imageCheck = async () => {
      const res = await request('login', 'imageCheck', imageCheckParams);
      if (res.code === 2000) {
        await getCompanyInfor();
        if (companyLen.value > 0) {
          if (!multiCompany.value) {
            await useLogin(form);
          } else {
            hideForm.value = true;
          }
        } else if (companyLen.value === 0) {
          Message.error('该用户暂未注册');
        }
      }
    };

    const companyInfor = reactive({
      companyList: [] as any[],
      supplierId: 1,
      selectCompany: {
        supplierCertId: '',
        supplierId: '',
        supplierName: ''
      }
    });

    const captchaObj = reactive({
      show: false,
      destroy: false,
      captchaId: 'TecentCaptcha',
      pass: false,
      handlerCaptcha: async (data: any) => {
        if (data.ret === 0) {
          captchaObj.destroy = true;
          captchaObj.pass = true;
          captchaObj.show = false;
          imageCheckParams.randStr = data.randstr;
          imageCheckParams.ticket = data.ticket;
          // if (!multiCompany.value) {
          await imageCheck();
        }
      },
    });

    // 获取绑定公司信息
    const getCompanyInfor = async () => {
      const result = verification('email') && verification('password');
      companyLen.value = -1;
      if (result) {
        const res = await request('login', 'checkCodeAndPassword', {
          workEmail: encrypt(form.workEmail),
          password: md5(form.password),
          checkCode: encrypt(form.checkCode)
        }) as Api.ResponseData;
        if (res.code === 2000) {
          res.data.companyList.forEach((i) => {
            i.supplierCertId = decrypt(i.supplierCertId);
            i.supplierId = decrypt(i.supplierId);
            i.supplierName = decrypt(i.supplierName);
          });
          companyInfor.companyList = res.data.companyList;

          multiCompany.value = companyInfor.companyList.length > 1;
          companyLen.value = companyInfor.companyList.length;
          Object.assign(companyInfor.selectCompany, { supplierCertId: res.data.companyList[0]?.supplierCertId, supplierId: res.data.companyList[0]?.supplierId, supplierName: res.data.companyList[0]?.supplierName });

          session.set('user-infor', JSON.stringify({
            workEmail: form.workEmail,
          }), config.session_maxAge);
        }
      }
    };

    // 监听邮箱以及密码，两者都有值才能获取公司信息
    // watchWithFilter([() => form.workEmail, () => form.password] as any, (newValues: any) => {
    //   if (newValues[0] && newValues[1]) {
    //     getCompanyInfor();
    //   }
    // },
    // {
    //   eventFilter: debounceFilter(500),
    //   immediate: true,
    // } as any);

    // 信息格式校验
    const verification = (type: string) => {
      switch (type) {
        case 'email':
          return verificaEmail(form.workEmail);
        case 'password':
          return verificaPassword(form.password);
        case 'code':
          return verificaCode(Number(form.checkCode));
        default:
          return false;
      }
    };

    const process = async () => {
      if (!checked.value) {
        Message.error('请先阅读并同意用户协议和隐私政策');
        return;
      }
      const result = verification('email') && verification('password') && verification('code');
      console.log(result);

      if (result) {
        console.log('process');
        captchaObj.show = true;
      } else {
        captchaObj.show = false;
        Message.error(verifyMsg.value);
      }
    };

    const joumToReset = async () => {
      root.$router.replace({ path: '/login/reset' });
    };

    return {
      formRoot,
      multiCompany,
      hideForm,
      form,
      login,
      // getCompanyInfor,
      verification,
      process,
      companyInfor,
      captchaObj,
      joumToReset,
      checked,
      dealVisible,
      dialogReadTitle,
      dialogReadType
    };
  },
});

